export default __webpack_public_path__ + "static/media/energy_deregulation.e461afdd.jpg";